import type { Source } from '@/api/types'

/** `[S<number>]` — one id per bracket, possibly adjacent (`[S1][S4]`). */
export const CITATION_PATTERN = /\[(S\d+)\]/g

/** "S12" → "12" (falls back to the raw id). */
export function sourceNumber(id: string): string {
  return /^S\d+$/.test(id) ? id.slice(1) : id
}

/** Remove citation markers for copy/paste, tidying the whitespace they leave behind. */
export function stripCitations(text: string): string {
  return text
    .replace(/[ \t]*\[S\d+\]/g, '')
    .replace(/[ \t]+([.,;:!?])/g, '$1')
    .replace(/[ \t]+$/gm, '')
}

/** Cited ids in order of first use, limited to ids present in `sources`. */
export function extractCitedIds(text: string, sources: Source[]): string[] {
  const known = new Set(sources.map((s) => s.id))
  const seen: string[] = []
  for (const match of text.matchAll(CITATION_PATTERN)) {
    const id = match[1]
    if (id && known.has(id) && !seen.includes(id)) seen.push(id)
  }
  return seen
}

/**
 * While streaming, a marker can arrive split across chunks ("…policy [S" + "2]").
 * Hide an incomplete trailing marker so it never flashes as raw text.
 */
export function trimPartialMarker(text: string): string {
  return text.replace(/\[(?:S\d*)?$/, '')
}
